import React from 'react';
import { Skeleton } from '@/shared/components/loading/Skeleton';

/**
 * Admin Users View Skeleton
 */
const AdminUsersSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 max-w-6xl mx-auto">
      {/* Header Bar */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white p-4 rounded-xl border border-neutral-200 shadow-sm">
        <div>
          <Skeleton className="h-6 w-48 rounded mb-1" />
          <Skeleton className="h-4 w-72 rounded" />
        </div>
        <Skeleton className="h-10 w-full md:w-72 rounded-lg" />
      </div>

      {/* Users Table */}
      <div className="bg-white border border-neutral-200 rounded-xl overflow-hidden">
        {/* Table Header */}
        <div className="bg-neutral-50 border-b border-neutral-200 px-6 py-4">
          <div className="grid grid-cols-12 gap-4">
            <Skeleton className="h-4 w-16 rounded" />
            <Skeleton className="h-4 w-24 rounded" />
            <Skeleton className="h-4 w-20 rounded" />
            <Skeleton className="h-4 w-20 rounded" />
            <Skeleton className="h-4 w-24 rounded" />
            <Skeleton className="h-4 w-16 rounded" />
            <Skeleton className="h-4 w-16 rounded" />
          </div>
        </div>

        {/* Table Rows */}
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="px-6 py-4 border-b border-neutral-100">
            <div className="grid grid-cols-12 gap-4 items-center">
              {/* User Info */}
              <div className="col-span-3 flex items-center gap-3">
                <Skeleton className="rounded-full" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-24 rounded" />
                  <Skeleton className="h-3 w-32 rounded" />
                </div>
              </div>

              {/* Plan */}
              <div className="col-span-2">
                <Skeleton className="h-6 w-20 rounded-full" />
              </div>

              {/* Status */}
              <div className="col-span-2">
                <Skeleton className="h-4 w-16 rounded" />
              </div>

              {/* Created */}
              <div className="col-span-2">
                <Skeleton className="h-4 w-24 rounded" />
              </div>

              {/* Invoices/Quotes */}
              <div className="col-span-2">
                <Skeleton className="h-4 w-20 rounded" />
              </div>

              {/* Actions */}
              <div className="col-span-1 flex gap-2">
                <Skeleton className="rounded" />
                <Skeleton className="rounded" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminUsersSkeleton;
